const removeHotJarInstallation = () => {
  const scripts = window.document.getElementsByTagName('script');
  // remove HotJar scripts
  for (let l = scripts.length, i = 0; i < l; i++) {
    const element = scripts.item(i);
    removeElements(element!);
  }

  // remove HotJar iframes
  const iframes = window.document.getElementsByTagName('iframe');
  for (let l = iframes.length, i = 0; i < l; i++) {
    const element = iframes.item(i);
    removeElements(element!);
  }

  // remove hj object
  (window as any).hj = null;
};

const removeElements = (element: HTMLScriptElement | HTMLIFrameElement) => {
  const src = element?.getAttribute('src');
  const id = element?.getAttribute('id');

  const hasSrc = src && src.indexOf('hotjar') > -1;
  const hasId = id && id.indexOf('_hj') > -1;

  if (hasSrc || hasId) {
    element.parentNode?.removeChild(element);
  }
};

export const loadHotJar = (location: string | number) => {
  const locationRef = String(location);
  const hotjarLocales: String = process.env.VUE_APP_HOTJAR_LOCATIONS || '';

  if (!hotjarLocales) {
    // Clear hotjar DOM twice to bruteforce removal
    removeHotJarInstallation();
    return removeHotJarInstallation();
  }

  const hotJarlocations = hotjarLocales.split(',');
  // remove HotJar for unsupported locations
  if (!hotJarlocations.includes(locationRef)) {
    // Clear hotjar DOM twice to bruteforce removal
    removeHotJarInstallation();
    removeHotJarInstallation();
  }
};
